import { useMemo, useState } from "react";
import { searchFieldWidth, searchLabelStyle, searchFormDefaultString } from "src/components/common/common";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchDateSingleForm } from "src/components/common/form/search/SearchDateSingleForm";
// 실시간 시계 표시용 (입력 불가)
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { CompanyDto } from "src/dtos/company/companyDto";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { useEQM1030_R01Store } from "./Store_EQM1030_R01";

export const SearchSection_EQM1030_R01 = () => {
    const { EQM1030_R01Filter, setEQM1030_R01Filter, latestUpdateTime } = useEQM1030_R01Store();
    const { compCdList } = useCommonCodeStore();

    const [pickerVisible, setPickerVisible] = useState(false);
    const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });

    const pad = (n: number) => n.toString().padStart(2, '0');
    const nowDisplay = useMemo(() => {
        const d = latestUpdateTime ? new Date(latestUpdateTime) : new Date();
        return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    }, [latestUpdateTime]);

    return (
        <SearchSectionForm>
            <SearchDropDownForm<CompanyDto>
                label="사업장"
                value={EQM1030_R01Filter.compCd}
                optionList={compCdList}
                onChangeValue={v => setEQM1030_R01Filter({ compCd: v === 'all' ? '' : v })}
            />
            <SearchDateSingleForm
                label="기준일자"
                visible={pickerVisible}
                setVisible={setPickerVisible}
                value={EQM1030_R01Filter.baseDate}
                onChange={(date) => setEQM1030_R01Filter({ baseDate: date })}
                pickerPosition={pickerPosition}
                setPickerPosition={setPickerPosition}
            />
            <div className={`${searchFieldWidth} mr-[10px]  flex items-center `}>
                <label className={`${searchLabelStyle} text-black mr-[5px]`}>현제시간</label>
                <span className={`inline-flex items-center px-[6px] h-[28px]  rounded-[6px] text-black bg-white select-none text-base`}>
                    {nowDisplay}
                </span>
            </div>
        </SearchSectionForm>
    );
};


